export default function removeEventListenerDomUtil (event, handler) {
  window.removeEventListener(event, handler)
}
